import * as React from 'react';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';

export default function DateField(props) {
    return (<TextField
        {...props}
        type="date"
        InputLabelProps={{
            shrink: true,
        }}
    />)
}